module.exports = __webpack_public_path__ + "static/font-6d32954eec9971bd1dcc760dfe38950d.woff";